import { render, staticRenderFns } from "./FitSettlement.vue?vue&type=template&id=55290a4d&"
import script from "./FitSettlement.vue?vue&type=script&lang=js&"
export * from "./FitSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports